module.exports = __webpack_public_path__ + "static/img/raisecore1.e6a0811.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/family/raisecore1.png
// module id = g8zq
// module chunks = 1